module.exports = __webpack_public_path__ + "img/partner-7.6a25a830.png";